import { render } from "./Order_digital.vue?vue&type=template&id=f88493f0&ts=true"
import script from "./Order_digital.vue?vue&type=script&lang=ts"
export * from "./Order_digital.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__